module.exports = __webpack_public_path__ + "static/img/h4-1.6fbdf38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/h4-1.png
// module id = ijjK
// module chunks = 1